module.exports = __webpack_public_path__ + "img/pro_two_4.0765c2bf.jpg";